import { AddressBookMagentoResponse, AddressBookResponse } from '../interfaces/address-book.interface';

export const mapAddressBookMagentoResponse = (addressBookResponse: AddressBookMagentoResponse): AddressBookResponse => {
  const addressBookContent = addressBookResponse.content;
  return {
    billingAddresses: addressBookContent.billing_addresses,
    shippingAddresses: addressBookContent.shipping_addresses,
    erpAccountNumber: addressBookContent.erp_account_number.toString(),
  };
};
